export enum GoEmissionDesignatorPowerType {
    FourK = '4K',
    SevenK = '7K',
    EightK = '8K',
    ElevenK = '11K',
}

export const GoEmissionDesignatorPowerTypeToLabelMapping = {
    [GoEmissionDesignatorPowerType.FourK]: '4K',
    [GoEmissionDesignatorPowerType.SevenK]: '7K',
    [GoEmissionDesignatorPowerType.EightK]: '8K',
    [GoEmissionDesignatorPowerType.ElevenK]: '11K',
};

export const GoEmissionDesignatorPowerTypeSortedArray = [
    GoEmissionDesignatorPowerType.FourK.valueOf(),
    GoEmissionDesignatorPowerType.SevenK.valueOf(),
    GoEmissionDesignatorPowerType.EightK.valueOf(),
    GoEmissionDesignatorPowerType.ElevenK.valueOf(),
];
